import { IconViewModel } from "./IconViewModel";
import { TrendViewModel } from "../system/admin-panel/Objects/Models/TrendViewModel";
import { OdometerViewModel } from "./OdometerViewModel";
import { VehicleSpecificationsPartViewModel } from "./VehicleSpecificationViewModel";
import { ObjectStatus } from "./ObjectStatusEnum";
import { ObjectServiceLogModel } from "./ObjectServiceLogModel";
import { IManagableObject } from "app/system/admin-panel/IManagableObject";

export class ObjectModel implements IManagableObject {
  Id: number = 0;
  OwnerId: number;//CompanyId
  IMEI?: number;
  Name: string = "";
  Comment: string = "";
  IconId: number = 0;
  TrackColor: string = "";
  Timeout: number = 600_000;
  Phone: string = "";
  ParkRadius: number = 50;
  MinParkTime: number = 300_000;
  DaysToStore: number = 400;
  Status: ObjectStatus = ObjectStatus.Active;
  FuelExpenseKm: number = 0;
  Number: number = 0;
  MaxSpeed: number = 110;
  DangerousSpeed: number = 130;
  HarshBreaking: number | null;
  HarshAcceleration: number | null;
  HarshTurn: number | null;
  DangerousBreaking: number | null;
  DangerousAcceleration: number | null;
  DangerousTurn: number | null;
  DeviceType: string = "";
  FuelExpenseHr: number = 0;
  CreateDate: Date;
  CreateUnix: number;
  StateNumber: string = "";
  InventoryNumber: string = "";
  MinIdleTime: number = 180_000;
  MinDrain: number = 8;
  Flags: string = "";
  MinDrainSpeed: number = 0.9;
  DefLat: number = 0;
  DefLng: number = 0;
  TimeZone: string = "";
  MaxDailyMileage: number = 0;
  Phone1: string = "";
  Address: string = "";
  PayedTill: number = 0;
  MaxDailyEngineTime: number = 0;
  MinMovingSpeed: number = 3;
  MinSatCount: number = 3;
  MinRefueling: number = 8;
  DetectDrainOnParkingOnly: boolean = true;
  DetectRefuelingOnParkingOnly: boolean = false;

  GroupIds: number[] = [];
  Sensors: TrendViewModel[] = [];
  EventIds: number[] = [];
  CommandIds: number[] = [];
  ServiceLogs: ObjectServiceLogModel[] = [];
  VehicleSpecifications: VehicleSpecificationsPartViewModel = new VehicleSpecificationsPartViewModel();
  Icon?: IconViewModel;

  Odometer: OdometerViewModel = new OdometerViewModel();
  IsChecked: boolean = false;
  protected init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.OwnerId = data["companyId"];
      this.IMEI = data["imei"];
      this.Name = data["name"];
      this.IconId = data["iconId"];
      this.TrackColor = data["trackColor"];
      this.Timeout = data["timeout"];
      this.Comment = data["comment"];
      this.Phone = data["phone"];
      this.ParkRadius = data["parkRadius"];
      this.MinParkTime = data["minParkTime"];
      this.DaysToStore = data["daysToStore"];
      this.Status = data["status"];
      this.FuelExpenseKm = data["fuelExpenseKm"];
      this.Number = data["number"];
      this.MaxSpeed = data["maxSpeed"];
      this.DangerousSpeed = data["dangerousSpeed"];
      this.HarshBreaking = data["harshBreaking"];
      this.HarshAcceleration = data["harshAcceleration"];
      this.HarshTurn = data["harshTurn"];
      this.DangerousBreaking = data["dangerousBreaking"];
      this.DangerousAcceleration = data["dangerousAcceleration"];
      this.DangerousTurn = data["dangerousTurn"];
      this.DeviceType = data["deviceType"];
      this.FuelExpenseHr = data["fuelExpenseHr"];
      this.CreateUnix = data["createDate"];
      this.StateNumber = data["stateNumber"];
      this.InventoryNumber = data["inventoryNumber"];
      this.MinIdleTime = data["minIdleTime"];
      this.MinDrain = data["minDrain"];
      this.Flags = data["flags"];
      this.MinDrainSpeed = data["minDrainSpeed"];
      this.DefLat = data["defLat"];
      this.DefLng = data["defLng"];
      this.TimeZone = data["timeZone"];
      this.MaxDailyMileage = data["maxDailyMileage"];
      this.Phone1 = data["phone1"];
      this.Address = data["address"];
      this.PayedTill = data["payedTill"];
      this.MaxDailyEngineTime = data["maxDailyEngineTime"];
      this.MinMovingSpeed = data["minMovingSpeed"];
      this.MinSatCount = data["minSatCount"];
      this.MinRefueling = data["minRefueling"];
      this.DetectDrainOnParkingOnly = data["detectDrainOnParkingOnly"];
      this.DetectRefuelingOnParkingOnly = data["detectRefuelingOnParkingOnly"];
      this.GroupIds = data["groupIds"] || [];
      this.EventIds = data["eventIds"] || [];
      this.CommandIds = data["commandIds"] || [];

      if (data["sensors"])
        data["sensors"].forEach(sensor => {
          this.Sensors.push(TrendViewModel.fromJS(sensor));
        })

      if (data["vehicleSpecifications"])
        this.VehicleSpecifications = VehicleSpecificationsPartViewModel.fromJS(data["vehicleSpecifications"]);

      if (data["serviceLogs"])
        data["serviceLogs"].forEach(log => {
          this.ServiceLogs.push(ObjectServiceLogModel.fromJS(log))
        })

    }
  }

  static fromJS(data: any): ObjectModel {
    data = typeof data === "object" ? data : {};
    let result = new ObjectModel();
    result.init(data);
    return result;
  }

  public HasFlag(str: string): boolean {
    return this.Flags.indexOf(str) >= 0;
  }
  public SetFlag(str: string) {
    if (!this.HasFlag(str))
      this.Flags = (this.Flags + " " + str).trim();
  }
  public ResetFlag(str: string) {
    this.Flags = this.Flags.replace(str, "").replace("  ", " ").replace("  ", " ").trim();
  }
}

